import store from '../store/index'
export default class lsSync {
  static syncData () {
    const userToken = localStorage.getItem('userToken')
    const botId = localStorage.getItem('botId')
    let userData = localStorage.getItem('userData')
    let roleId = parseInt(localStorage.getItem('roleId'))
    if (userData) {
      userData = JSON.parse(userData)
      store.dispatch('setUserData', userData)
    }
    store.dispatch('setUserToken', userToken)
    store.dispatch('setBotId', botId)
    store.dispatch('setRoleId', roleId)
  }
}
